import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function VaccinationMenu() {
    const MenuCard = ({
                          link,
                          title,
                          icon,
                          color
                      }) => (
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-4">

            <Link
                to={link}
                className="menu-link"
            >

                <div
                    className="menu-card"
                    style={{
                        borderTop: `4px solid ${color}`
                    }}
                >

                    <div
                        className="menu-icon"
                        style={{
                            color: color
                        }}
                    >

                        <FontAwesomeIcon
                            icon={icon}
                            size="2x"
                        />

                    </div>

                    <p className="menu-title">
                        {title}
                    </p>

                </div>

            </Link>

        </div>
    );
    return (
        <section className="container-fluid mt-4">

            {/* =====================================================
                VACCINATION MANAGEMENT
            ===================================================== */}

            <h5 className="menu-section-title">
                Vaccination Management
            </h5>

            <div className="row">

                <MenuCard
                    link="/vaccine-management"
                    title="Vaccination Management"
                    icon="fa-solid fa-syringe"
                    color="#20c997"
                />

                <MenuCard
                    link="/patient-vaccine"
                    title="Patient Vaccination"
                    icon="fa-solid fa-user-shield"
                    color="#6f42c1"
                />

                <MenuCard
                    link="/vaccination-appointments"
                    title="Vaccination Appointments"
                    icon="fa-solid fa-calendar-check"
                    color="#0d6efd"
                />

                <MenuCard
                    link="/vaccination/administration"
                    title="Vaccination Administration"
                    icon="fa-solid fa-syringe"
                    color="#fd7e14"
                />

            </div>


            {/* =====================================================
                VACCINATION CERTIFICATE
            ===================================================== */}

            <h5 className="menu-section-title">
                Vaccination Certificate
            </h5>

            <div className="row">

                <MenuCard
                    link="/vaccination/certificate"
                    title="Vaccination Certificate"
                    icon="fa-solid fa-certificate"
                    color="#fd7e14"
                />

            </div>


            {/* =====================================================
                VACCINATION REPORTS
            ===================================================== */}

            <h5 className="menu-section-title">
                Vaccination Reports
            </h5>

            <div className="row">

                <MenuCard
                    link="/vaccination/reports"
                    title="Vaccination Reports"
                    icon="fa-solid fa-file-medical"
                    color="#0d6efd"
                />

            </div>


            {/* =====================================================
                VACCINATION DASHBOARD
            ===================================================== */}

            <h5 className="menu-section-title">
                Vaccination Dashboard
            </h5>

            <div className="row">

                <MenuCard
                    link="/vaccination/dashboard"
                    title="Vaccination Dashboard"
                    icon="fa-solid fa-gauge-high"
                    color="#198754"
                />

            </div>

        </section>
    );
}
export default VaccinationMenu;
